module.exports = __webpack_public_path__ + "static/media/schedule-icon.187c9a35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/schedule-icon.svg
// module id = 2878
// module chunks = 0